// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__D3WGv","submit":"style_submit__TuCxM","label":"style_label__ObDoo","events":"style_events__FJK5s","empty":"style_empty__QsnkP","footer":"style_footer__qh5SQ"};